import { useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
// import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { VscLoading, VscHome } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import { FormGroup } from '../../Components/FormGroup/FormGroup';
import { loginUser } from '../../Redux/slices/user';
import { useSelector } from 'react-redux';
import SigninWithOTP from './components/SigninWithOTP';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

// import { logValidationSchema } from '../../_helpers/validations/logValidationSchema';

const Login = () => {
  const loading = useSelector((state) => state.user.loading);
  const appliedEvent = useSelector((state) => state.event.appliedEvent);
  const [searchParams] = useSearchParams();
  let usernameValue = searchParams.get('username');
  let login_type = searchParams.get('login_type');
  const [loginType, setLoginType] = useState('basic');
  const dispatch = useDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    if (usernameValue || login_type === 'otp') {
      setLoginType('OTP');
    }
  }, [usernameValue, login_type]);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onBlur'
  });

  const handleLogin = (user) => {
    let redirectTo = false;
    if (appliedEvent) {
      redirectTo = '/events/' + appliedEvent;
    }
    console.log(redirectTo, 'redirectTo');
    dispatch(loginUser(user, navigate, redirectTo));
  };

  return (
    <div className="login positive-relative">
      <StyledLoginWrapper className="login__wrapper">
        <div className="login__form">
          <Link to="/" title="Homepage" className="homepage-link">
            <VscHome className="homepage-link-icon" />
            <div className="title_container d-flex">
              <div className="logo-wrapper text-center">
                <img src="/assets/images/logo.webp" alt="logo" className="logo" />
              </div>
              <div className="logo-text">
                <span className="brand-main w-max-content">
                  <FormattedMessage id="government_of_nepal" /> <br />
                  <FormattedMessage id="ministry_of_federal_afairs_and_general_administration" />
                </span>
                <span className="d-block text-danger sub-title">
                  <FormattedMessage id="provincial_and_local_goverment_support_program" />
                </span>
              </div>
            </div>
          </Link>
          <span className="main-title">
            <FormattedMessage id="login" />
          </span>

          {loginType === 'basic' ? (
            <Form onSubmit={handleSubmit(handleLogin)}>
              <div className="mb-4">
                <Form.Group>
                  <FormattedMessage id="phone_or_email">
                    {(placeholder) => (
                      <FormGroup
                        label={placeholder[0]}
                        type="text"
                        placeholder={placeholder[0]}
                        errorId="Phone_no_email"
                        id="username"
                        register={register}
                        error={errors}
                        disabled={loading}
                        required={true}
                      />
                    )}
                  </FormattedMessage>
                </Form.Group>
                <Form.Group className="mt-3">
                  <FormattedMessage id="password_or_pin">
                    {(placeholder) => (
                      <FormGroup
                        label={placeholder[0]}
                        type="password"
                        passwordType="password"
                        id="password"
                        placeholder={placeholder[0]}
                        errorId="password_pin"
                        required={true}
                        register={register}
                        disabled={loading}
                        error={errors}
                      />
                    )}
                  </FormattedMessage>
                </Form.Group>
                {/* <Form.Group className="mt-1">
                  <Form.Check name="checkbox" label="Remember me" />
                </Form.Group> */}
              </div>
              <Button
                className="btn-success my-2 d-block btn-round"
                disabled={loading}
                type="submit">
                {loading ? <VscLoading className="spin" /> : <FormattedMessage id="login" />}
              </Button>
            </Form>
          ) : (
            <SigninWithOTP
              handleSubmit={handleSubmit}
              handleLogin={handleLogin}
              register={register}
              errors={errors}
              loading={loading}
              usernameValue={usernameValue}
            />
          )}
          <div className="d-flex">
            {loginType === 'basic' ? (
              <Button
                className="btn-sm btn-otp-alt d-block btn-round w-50"
                onClick={() => setLoginType('OTP')}>
                <FormattedMessage id="login_with_otp" />
              </Button>
            ) : (
              <Button
                className="btn-sm btn-otp-alt d-block btn-round w-50"
                onClick={() => setLoginType('basic')}>
                <FormattedMessage id="login_with_password_or_pin" />
              </Button>
            )}
            <Link to="/forgot" className="forgot-password mt-1 w-50">
              <FormattedMessage id="forgot_password" />
            </Link>
          </div>
          <span className="sub-title-outline">
            <FormattedMessage id="or" />
          </span>
          <Link to="/rosters/apply" className="w-100 my-2 btn btn-primary">
            <FormattedMessage id="signup_as_resource_person" />
          </Link>

          <Link to="/trainees/apply" className="my-2 w-100 btn btn-danger">
            <FormattedMessage id="signup_as_participant" />
          </Link>
          <hr />
          <div className="copyright">
            <p>
              Powered by :{' '}
              <a href="https://ideabreed.net/" target="_blank" rel="noreferrer">
                Idea Breed IT Solution Pvt. Ltd.
              </a>
            </p>
          </div>
        </div>
      </StyledLoginWrapper>
    </div>
  );
};

export default Login;

const StyledLoginWrapper = styled.div`
  &:before {
    background-image: url('/assets/images/nepal-map.svg');
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #bee0f6;
    opacity: 0.4;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    content: '';
    z-index: -1;
  }
`;
